<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-housing-subsidy`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.062 3.524L44.1 16.064a2 2 0 01.9 1.67v25.064a2 2 0 01-2 2H5a2 2 0 01-2-2V17.735a2 2 0 01.897-1.669l18.962-12.54a2 2 0 012.203-.002zm-1.098 3.678L7 18.679v22.523h34v-22.52L23.964 7.201zM21.027 17.21l.094.083 2.914 2.913 2.915-2.913a1 1 0 011.414 0l1.414 1.414a1 1 0 010 1.414l-3.465 3.464H30a1 1 0 011 1v2a1 1 0 01-1 1h-4v2h4a1 1 0 011 1v2a1 1 0 01-1 1h-4v3a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4v-2h-4a1 1 0 01-1-1v-2a1 1 0 011-1h3.756l-3.463-3.464a1 1 0 01-.083-1.32l.083-.094 1.414-1.414a1 1 0 011.32-.083z"/></svg>
</template>
<script>

export default {
  name: 'IconHousingSubsidy',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
